import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as L}from"../../icon-registry.js";const d=L("wallis_and_futuna",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#CE1126" />
            <path
                d="M0 4.5L7.93419 4.5L7.93419 9.78946H0L0 4.5Z"
                fill="white" />
            <path
                d="M0 4.5L3.9671 4.5L3.9671 9.78946H0L0 4.5Z"
                fill="#002654" />
            <path
                d="M12.0005 9.85558L0 9.85558L0 9.72334L11.8021 9.72334V4.5H12.0005V9.85558Z"
                fill="white" />
            <path
                d="M17.7892 14.8954L14.9092 12.5H20.6692L17.7892 14.8954ZM16.8292 15.6938L13.9492 13.2985L13.9492 18.0892L16.8292 15.6938ZM17.7892 16.4923L14.9092 18.8877H20.6692L17.7892 16.4923ZM18.7492 15.6938L21.6292 13.2985V18.0892L18.7492 15.6938Z"
                fill="white" />
        </svg>
    `),p=L("wallis_and_futuna_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_96590)">
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="#CE1126" />
                <path
                    d="M0 0.5L7.93419 0.5L7.93419 8.43419H0L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 0.5L3.9671 0.5L3.9671 8.43419H0L0 0.5Z"
                    fill="#002654" />
                <path
                    d="M12.0005 8.53337L0 8.53337L0 8.33502L11.8021 8.33502L11.8021 0.5H12.0005L12.0005 8.53337Z"
                    fill="white" />
                <path
                    d="M17.7892 11.5402L14.9092 8.66016L20.6692 8.66016L17.7892 11.5402ZM16.8292 12.5002L13.9492 9.62016L13.9492 15.3802L16.8292 12.5002ZM17.7892 13.4602L14.9092 16.3402H20.6692L17.7892 13.4602ZM18.7492 12.5002L21.6292 9.62016V15.3802L18.7492 12.5002Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_96590">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as WallisAndFutuna,p as WallisAndFutunaRounded};
